import React, { Suspense } from "react";
import { lazyComReload } from "utils/lazyComReload";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { DARKSIDE_PREFIX_PATH } from "configs/AppConfig";
import AccessGuard from "./AccessGuard";

export const DarksideViews = () => {
	return (
		<Suspense fallback={<Loading cover="page" />}>
			<Switch>
				<Route
					path={`${DARKSIDE_PREFIX_PATH}`}
					render={() => (
						<AccessGuard>
							{React.createElement(lazyComReload(() => import("./home")))}
						</AccessGuard>
					)}
				/>
				<Redirect
					from={DARKSIDE_PREFIX_PATH}
					to={`${DARKSIDE_PREFIX_PATH}`}
				/>
			</Switch>
		</Suspense>
	);
};

export default DarksideViews;
